import React from 'react';
import PropTypes from 'prop-types';
import SwitchableOdds from '~spa/Components/SwitchableOdds';
import { getOddsBoostSelection } from '../utils';
import './styles/oddsBoostWidget.scss';

const BetCardDescription = ({ data }) => {

    const oddsBoostSelection = getOddsBoostSelection(data.selection);

    return (
        <>
            <div className='odds-boost-widget__description'>
                <span className='odds-boost-widget__selection-name'>{data.selection.name}</span>
                <span className='odds-boost-widget__event-name'>{data.event_name}</span>
            </div>
            <div className='odds-boost-widget__wasprice'>
                <span className={'odds-boost-widget__wasprice--button-template'}>
                    <SwitchableOdds selection={oddsBoostSelection} />
                </span>
            </div>
        </>
    );
};

BetCardDescription.propTypes = {
    data: PropTypes.object.isRequired,
};

export default BetCardDescription;
